module.exports = __webpack_public_path__ + "media/images/landing_page/failiem_upload_pc (copy)-bfecd4d7537a98f2dda7ed8acc0296fd.png";